export default "../a79b7ae7b13592666f75206f792014c7.png";